export enum FilterDone {
  ALL,
  REMAINING,
  DONE,
}
